export const isOptionLink = (option) => {
    return option.navigate === true;
};
